import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { getEntityUrl } from '@culture/utils/helpers/entities';

import EntityPropTypes from 'propTypes/entities';

import {
	cardCropTextDefault,
	cardIcons,
	imageCardSizeDefault
} from 'utils/helpers/entities';

import BaseCard from './BaseCard';

const MovieCard = ({
	className,
	cropTextParams,
	entity,
	params,
	typeWidth
}) => {
	const { title, thumbnailFile, type, institute } = entity;
	const url = getEntityUrl('movies', entity);
	const description = institute && institute.title;
	const isMoviePortraitCard = _(['movie', 'performance']).contains(type);
	let attributes = null;
	const badges = [];
	let imageParams;

	if (params) {
		imageParams = params;
	} else if (isMoviePortraitCard) {
		imageParams = imageCardSizeDefault.portrait;
	} else {
		imageParams = imageCardSizeDefault.landscape;
	}

	if (isMoviePortraitCard) {
		const { year, duration, genres } = entity;
		const genre = genres?.[0]?.title;

		attributes = _.compact([
			genre,
			year,
			duration && `${Math.ceil(duration / 60)}\u00A0мин`
		]);
	}

	if (entity.tifloComments) {
		badges.push(cardIcons.tifloComments);
	}

	return (
		<BaseCard
			{...{
				attributes,
				badges,
				className,
				cropTextParams,
				description,
				thumbnailFile,
				title,
				typeWidth,
				url
			}}
			params={imageParams}
		/>
	);
};

MovieCard.propTypes = {
	className: PropTypes.string,
	cropTextParams: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string
	}),
	entity: EntityPropTypes.movie.isRequired,
	params: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	typeWidth: PropTypes.oneOf([
		'fluidLandscapeSlide',
		'fluidPortraitSlide',
		'fixedLandscape',
		'fixedPortrait',
		'landingLandscape',
		'landingPortrait'
	])
};

MovieCard.defaultProps = {
	cropTextParams: cardCropTextDefault
};

export default MovieCard;
